import { cn } from '@frontdoor/ui/lib/utils';
import type { LucideIcon } from 'lucide-react';

export type StepState = 'completed' | 'current' | 'future' | 'action';

type ProgressStepIconProps = {
  icon: LucideIcon;
  state: StepState;
};

const stateStyles: Record<StepState, { circle: string; icon: string }> = {
  completed: {
    circle: 'bg-hydrangea-700',
    icon: 'text-white',
  },
  current: {
    circle: 'bg-hydrangea-200',
    icon: 'text-hydrangea-700',
  },
  action: {
    circle: 'bg-rose-200',
    icon: 'text-rose-700',
  },
  future: {
    circle: 'bg-sand-100',
    icon: 'text-charcoal-400',
  },
};

export function ProgressStepIcon({ icon: Icon, state }: ProgressStepIconProps) {
  const styles = stateStyles[state];

  return (
    <div className={cn('flex size-8 items-center justify-center rounded-full', styles.circle)}>
      <Icon className={cn('size-4', styles.icon)} />
    </div>
  );
}
